import React, { useState } from 'react';

function Index() {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (src) => {
    setSelectedImage(src);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="w-full mt-40 mb-20 flex flex-col items-center">
      <div className="w-[80%]">
        <div className="columns-1 sm:columns-2 md:columns-2 gap-4 space-y-4">
          {Array.from({ length: 26 }, (_, i) => {
            const src = `/images/visuals/${i + 1}.png`;
            return (
              <img
                key={i}
                className="w-full h-auto cursor-pointer hover:opacity-90"
                src={src}
                alt={`Gallery ${i + 1}`}
                loading="lazy"
                onClick={() => handleImageClick(src)}
              />
            );
          })}
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <img
            src={selectedImage}
            alt="Enlarged"
            className="max-w-[90%] max-h-[90%] shadow-xl rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}

export default Index;
